import { PersonModel, ScheduleModalPeople } from '@/types';

export const person: PersonModel = {
  name: 'Wiktor',
  surname: 'Stefański',
  position: 'Head of People & Operations',
  linkedinLink: 'https://www.linkedin.com/in/w-stefanski/',
  modal: ScheduleModalPeople.wiktorS
};
